<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" sm="12" md="6">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Brand/model"
          v-model="record.Name"
        ></v-text-field>
      </v-col>
        
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-btn  color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    categories: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.loader = true;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
  },
  created() {},
};
</script>